module.exports = "<p>\r\n  Redirecting to Telemed for Life\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sso/sso.component.html
// module id = ./src/app/sso/sso.component.html
// module chunks = main